/**
 *
 *  Booking Panel
 *  Component
 *
 *  Created by Vladimir Shislyannikov on 09/12/2021.
 *  Copyright (c) 2021 iWoo Ltd. All rights reserved.
 *
 */

import React, {
  /*useImperativeHandle, useRef, */ useEffect /*, useLayoutEffect*/,
  useCallback,
  useState,
  useMemo,
  ChangeEvent,
} from 'react';
// import ReactDOM from 'react-dom';
import {
  // Platform,
  // StatusBar,
  Animated,
  // ScrollView,
  StyleSheet,
  // TextStyle,
  ViewStyle,
  // useWindowDimensions,
  // Dimensions,
  // Text,
  View,
  // PanResponderGestureState,
  // NativeSyntheticEvent,
  // NativeScrollEvent
} from 'react-native';
// import { useSafeAreaInsets } from 'react-native-safe-area-context';
// import { connect } from 'react-redux';
// import { decrementCounter, incrementCounter } from './counterSlice'
// import clsx from 'clsx';
// import PropTypes from 'prop-types';
import { Area, AreaUK } from '../../types';
// import { Helmet } from 'react-helmet';
// import { Link } from 'react-router-dom';
// import { loadPartnerProfile } from 'mainApp/actions/partner';
// import {
//     changeDrawerState,
// } from 'mainApp/actions/ui';

import {
  // Button,
  // Dialog,
  // DialogActions,
  // DialogContent,
  // DialogTitle,
  // Divider,
  // FormControl,
  // Grid,
  // Box,
  // InputLabel,
  // MenuItem,
  // Select,
  TextField,
  Theme,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// utils
import {
  // css,
  // isIosDevice,
  // getViewportHeight,
  debounce,
} from '../../utils';
import * as _ from '../../utils/_';
// import { LIVE_STREAM_PRICE, LOCATION_TYPES } from 'mainApp/constants';

// components
import SlidingUpPanel /*SlidingUpPanelAnimationConfig*/ from 'rn-sliding-up-panel';
import RoundedContainer from '../RoundedContainer/RoundedContainer';
import AddArea from '../AddArea/AddArea';

import CloseIcon from '../../icons/Close2Icon';
// import Icon from 'mainApp/components/Icon';
// import { ProgressiveImage } from 'mainApp/components/ProgressiveImage';
// import { DirectBookingForm } from 'mainApp/components/DirectBookingForm';
// import DrawerGoals from 'mainApp/components/DrawerGoals';
// import DrawerDayAndTime from 'mainApp/components/DrawerDayAndTime';
// import DrawerSessionType from 'mainApp/components/DrawerSessionType';

// import BookingFlowSessionSelector from 'mainApp/components/BookingFlowSessionSelector';

// hooks
import useHeight from '../../hooks/useHeight/useHeight';
import useBodyScrollLock from '../../hooks/useBodyScrollLock/useBodyScrollLock';

import { areas } from '../../areas';
import { areas as areasUK /* : { areas : AreaUK[] }*/ } from '../../areas-uk';

// import defaultTrainerPhoto from 'images/generic-trainerphoto.svg';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '600px',
    'min-height': '400px',
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100vw - 32px)',
    },
    '& .inputSelect': {
      width: 'calc(100% - 35px)',
    },
  },
  districtInputContainer: {
    display: 'flex',
    // textAlign="center"
    'padding-top': '24px',
    'padding-bottom': '24px',
    'padding-left': '16px',
    'padding-right': '16px',
    width: '100%',
    'background-color': theme.greyLight,
    // justifyContent="space-between"
  },
  button: {
    float: 'right',
  },
  paper: {
    [theme.breakpoints.down('xs')]: {
      margin: '16px',
    },
  },
  drawer: {},
  gutterBottom: {
    'margin-bottom': '1em',
  },
  headline: {
    'margin-bottom': '1.3em',
    'font-size': '1.1rem',
  },
  listSection: {
    margin: '2em 0 0.8em',
    '&:first-child': {
      margin: '1em 0 2em 0',
    },
  },
  closeDrawer: {
    cursor: 'pointer',
    display: 'flex',
    background: 'transparent',
    border: '0',
    margin: '0',
    padding: '0',
    color: theme.red,
  },
}));

// const { height: deviceHeight } = Dimensions.get('window');

// const propTypes = {
//   // children: PropTypes.object, // JSX.Element,
//   onClose: PropTypes.func,
//   // activeState: PropTypes.string,
//   // title: PropTypes.string,
//   // subtitle: PropTypes.string,
//   // onNextClick: PropTypes.func.isRequired,
// };

const defaultProps = {
  // bookingStep: 1,
  isOpening: true,
  allowDragging: false,
};

// const styles = {

// };

// const panelStyles = {
//   backdrop: {
//       position: 'fixed',
//       'z-index': 1000,
//   },
//   container: {
//     position: 'fixed',
//     // flex: 1,
//     // 'background-color': 'rgb(255, 255, 255)',
//     // 'align-items': 'center',
//     // 'justify-content': 'center',
//     'z-index': 1000,
//   },
// };

const CLOSE_TIMEOUT = 300;

// interface ErrorDialogProps {
//   dismissError: Function;
//   error: TwilioError | Error | null;
// }

// type ReactNode = {} | null | undefined;

// type Props = {
//   title: string;
//   children?: React.ReactNode;
// };

// const ios = Platform.OS === 'ios';

interface AddAreaPopupProps {
  children?: any; // React.ReactElement; // React.ReactNode;
  isOpen: boolean;
  isOpening?: boolean;
  isFetching: boolean;
  allowDragging: boolean;
  title: string;
  region?: string;
  draggableRange?: any;
  snappingPoints?: any;
  containerStyle?: any;
  // onClose(...args: any[]): any;
  onClose(): void;
  onBottomReached?: any;
  // type: "submit" | "button";
}

type Ref = HTMLElement;

/**
 * @public
 */
export const AddAreaPopup = React.forwardRef<Ref, AddAreaPopupProps>((props, outerRef) => {
  const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);
  const [isFullyOpen, setIsFullyOpen] = useState<boolean>(false);
  // const [scrollEnabled, setScrollEnabled] = useState<boolean>(true);
  // const [allowDragging, setAllowDragging] = useState<boolean>(props.allowDragging);
  // const [atTop, setAtTop] = useState<boolean>(true);
  const [atBottom, setAtBottom] = useState<boolean>(true);

  const allAreas: Area[] = useMemo(() => (props.region === 'US' ? areas : areasUK.map(mapAreaUKtoArea)), [
    props.region,
  ]);

  const [filteredAreas, setFilteredAreas] = useState<Area[]>(allAreas);
  // const [backdropShow, setBackdropShow] = useState<boolean>(false);

  // const dispatch = useDispatch();

  // console.log('allowDragging: ', allowDragging);

  // const deviceHeight = useWindowDimensions().height;
  const deviceHeight: number = useHeight(); // getViewportHeight();
  // const insets = useSafeAreaInsets();
  const statusBarHeight: number = 24; //ios ? insets.bottom : StatusBar.currentHeight as number;

  const classes = useStyles();

  const draggableRange = props.draggableRange
    ? props.draggableRange
    : {
        top: deviceHeight - statusBarHeight,
        bottom: 0, // deviceHeight / 2.8
      };

  const snappingPoints = props.snappingPoints
    ? props.snappingPoints
    : [
        draggableRange.top,
        // draggableRange.bottom
      ];

  const panelRef = React.useRef<SlidingUpPanel>(null);
  const districtInputRef = React.useRef<HTMLInputElement>(null);
  const [panelPositionVal] = useState(new Animated.Value(draggableRange.bottom));
  const panelPositionValueListenerRef = React.useRef('');

  // const attachRef = useCallback(node => {
  //   const ref = props.attachRef;
  //   // const {
  //       // attachLocationPickerRef: ref
  //   // } = props;

  //   panelRef.current = node;

  //   if (ref == null) {
  //       return;
  //   }

  //   if (typeof ref === 'function') {
  //       ref(node);

  //       return;
  //   }

  //   if (typeof ref === 'object') {
  //       ref.current = node;
  //       return;
  //   }
  // }, []);

  // useEffect(() => {
  //     if (props.partner && props.partner.id && props.partner.id !== 0) {
  //         props.loadPartnerProfile(props.userId !== '0' ? props.userId : undefined, props.partner.id);
  //     }
  // }, [props.partner]);

  const onAnimatedValueChange = useCallback(
    ({ value }) => {
      // console.log('onAnimatedValueChange draggableRange.top', draggableRange.top);
      if (value === draggableRange.top) {
        // At top position
        // console.log('At top position');
        setIsFullyOpen(true);
        setAtBottom(false);
      }

      // console.log('onAnimatedValueChange.value: ', value);

      // console.log('draggableRange.top: ', draggableRange.top);
      // console.log('draggableRange.bottom: ', draggableRange.bottom);

      if (value === draggableRange.bottom) {
        // At bottom position
        // console.log('At bottom position');
        // setAtBottom(true);
        // setIsFullyOpen(false);
      }
    },
    [draggableRange.top, draggableRange.bottom]
  );

  const close = useCallback(() => {
    return new Promise((resolve, reject) => {
      setIsFullyOpen(false);
      panelRef && panelRef?.current?.hide();

      // setBackdropShow(false);

      // Reset filter
      setFilteredAreas([...allAreas]);

      // props.onClose && props.onClose();

      setTimeout(() => {
        panelPositionVal.removeListener(panelPositionValueListenerRef.current);
        panelPositionValueListenerRef.current = '';
        //   setIsOpen(false);
        //   setIsFullyOpen(false);
        // props.onClose && props.onClose();
        resolve(null);
      }, CLOSE_TIMEOUT);
    });
  }, [panelPositionVal /*, props.onClose*/]);

  useEffect(() => {
    if (!panelRef.current) {
      if (!props.isOpen && isOpen) {
        setIsOpen(false);
      }

      return;
    }

    if (props.isOpen) {
      let targetEl = panelRef.current;

      // setTimeout(() => {
      // const deviceHeight = useWindowDimensions().height; // .get('window');

      // targetEl.show(deviceHeight - 24/* , 0.5 */); // 24px top gap with 0.5 velocity
      setAtBottom(false);
      targetEl.show(draggableRange.top);
      // targetEl.show({
      //   velocity: PANEL_VELOCITY,
      //   toValue: draggableRange.top
      // });
      // }, 300);

      // setTimeout(() => {
      //   panelRef?.current?.forceUpdate();
      // }, 300);
    }

    if (props.isOpen && !isOpen) {
      setIsOpen(true);
      // setBackdropShow(true);
    } else if (!props.isOpen && isOpen) {
      // setIsOpen(false);
      setTimeout(() => {
        setIsOpen(false);
      }, CLOSE_TIMEOUT);

      close();
    }

    return () => {};
  }, [props.isOpen, draggableRange.top, isOpen, close]);

  useEffect(() => {
    // console.log('useEffect draggableRange.top', draggableRange.top);
    if (panelPositionValueListenerRef.current !== '') {
      panelPositionVal.removeListener(panelPositionValueListenerRef.current);
      panelPositionValueListenerRef.current = '';
    }

    if (isOpen) {
      panelPositionValueListenerRef.current = panelPositionVal.addListener(onAnimatedValueChange);

      panelRef?.current?.show(draggableRange.top);
    }
  }, [isOpen, panelPositionVal, draggableRange.top, onAnimatedValueChange]);

  // useEffect(() => {
  //   panelRef?.current?.show(draggableRange.top);
  // }, [draggableRange.top]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(
    () => () => {
      props.isOpen && props.onClose && props.onClose();
    },
    [props.isOpen, props.onClose]
  );

  // hideDrawer () {
  //     return new Promise((resolve, reject) => {
  //         this.DrawerRef.hide();

  //         setTimeout(() => {
  //             this.context.changeDrawerState(null);
  //             this.context.hideDrawer();

  //             resolve();
  //         }, 500);
  //     });
  // },

  const handleBottomReached = () => {
    setAtBottom(true);
    // close();
    // setIsOpen(false);
    // setIsFullyOpen(false);
    // props.onClose && props.onClose();
    props.onBottomReached && props.onBottomReached();
    // resolve(null);
  };

  // const handleBottomReached =  useCallback(() => {
  //   // close();
  //   // setTimeout(() => {
  //     setIsOpen(false);
  //     setIsFullyOpen(false);
  //     props.onClose && props.onClose();

  //     // // Reset filter
  //     // setFilteredAreas([...areas]);
  //     // resolve(null);
  //   // }, CLOSE_TIMEOUT);
  // }, [props.onClose, setIsOpen]);

  // fired when panel is finished being dragged up or down
  // if panel is dragged to 'top' position, then we switch to scrollmode
  // const onMomentumDragEnd = useCallback((value: number) => {
  //   if (value === draggableRange.top && !scrollEnabled) {
  //     setScrollEnabled(true);
  //     setAtTop(true);
  //   }
  // }, [draggableRange, scrollEnabled, setScrollEnabled, setAtTop]);

  // fired when scroll is finished inside the panel,
  // if the content in the panel has scrolled to the very top,
  // then we allow the panel to be dragged down
  // (only if the next gesture is down, not up)
  // const onMomentumScrollEnd = useCallback(({ clientHeight, scrollHeight, scrollTop }: { clientHeight: number, scrollHeight: number, scrollTop: number }) => {
  // const onMomentumScrollEnd = useCallback((event: NativeSyntheticEvent<NativeScrollEvent>) => {
  //   const { nativeEvent } = event;

  //   if (nativeEvent.contentOffset.y === 0) {
  //   // if (scrollTop === 0) {
  //     setAtTop(true);

  //     // if (ios) {
  //       // setAllowDragging(true);
  //     // }
  //   }
  // }, [setAtTop, setAllowDragging]);

  // fired when scroll is finished inside the panel,
  // if the content in the panel has scrolled to the very top,
  // then we allow the panel to be dragged down
  // (only if the next gesture is down, not up)
  // const onScroll = useCallback(({ clientHeight, scrollHeight, scrollTop }: { clientHeight: number, scrollHeight: number, scrollTop: number }) => {
  // // const onMomentumScrollEnd = useCallback((event: NativeSyntheticEvent<NativeScrollEvent>) => {
  //   // const { nativeEvent } = event;

  //   return;
  //   // if (nativeEvent.contentOffset.y === 0) {
  //   if (scrollTop === 0) {
  //     setAtTop(true);

  //     // if (ios) {
  //       setAllowDragging(true);
  //     // }
  //   }
  // }, [setAtTop, setAllowDragging]);

  // const PANEL_VELOCITY = (ios || isIosDevice) ? 1 : 2.3;
  // const hideFullScreenPanelOptions: SlidingUpPanelAnimationConfig = {
  //   velocity: PANEL_VELOCITY,
  //   toValue: draggableRange.bottom
  // };

  // if panel is at the top and scrolling is allowed
  // check the velocity of the drag,
  // if the velocity is downward, then we animate the panel to its bottom state
  // if the velocity is upward, we treat the drag like a scroll instead
  // const onDragStart = useCallback((_: number, gestureState: PanResponderGestureState) => {

  //   // console.log('onDragStart - gestureState.vy: ', gestureState.vy, 'atTop: ', atTop, 'scrollEnabled: ', scrollEnabled);

  //   if (atTop && scrollEnabled) {
  //     if (gestureState.vy > 0) { // Swipe up. Swipe down it's a minus
  //       setScrollEnabled(false);

  //       // if (ios) {
  //         setAllowDragging(true);
  //       // }

  //       if (panelRef && panelRef.current) {
  //         panelRef?.current?.show(/*hideFullScreenPanelOptions*/);
  //         // console.log('show!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
  //       }
  //     } else {
  //       setAtTop(false);

  //       // if (ios) {
  //         setAllowDragging(false);
  //       // }
  //     }
  //   }
  // }, [atTop, scrollEnabled, panelRef, setAtTop, setAllowDragging, setScrollEnabled]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleDisctrictInputChange = useCallback(
    debounce((e: ChangeEvent<HTMLInputElement>) => {
      // setDistrictFilter(e.target.value)
      // Access input value
      // const query = e.target.value;

      const query = districtInputRef.current?.value;

      // Create copy of item list
      var updatedList = [...allAreas];

      // Include all elements which includes the search query

      updatedList = allAreas.filter(
        v =>
          v.zipCode.toLowerCase().includes(query!.toLowerCase()) ||
          v.city.toLowerCase().includes(query!.toLowerCase()) ||
          // @ts-ignore
          v.neighbourhood?.toLowerCase().includes(query!.toLowerCase()) ||
          v.county?.toLowerCase().includes(query!.toLowerCase()) ||
          // @ts-ignore
          v.region?.toLowerCase().includes(query!.toLowerCase())
      );

      const areasByRegion = _.groupBy(updatedList, 'region');

      updatedList = [];

      Object.keys(areasByRegion)
        .filter(v => v)
        .forEach(key => {
          // @ts-ignore
          updatedList.push({ zipCode: '', city: '', region: key });
          updatedList = updatedList.concat(areasByRegion[key]);
        });

      if (areasByRegion[''] && areasByRegion[''].length) {
        // @ts-ignore
        updatedList.push({ zipCode: '', city: '', region: 'All Others' });
      }
      updatedList = updatedList.concat(areasByRegion[''] ? areasByRegion[''] : []);

      if (updatedList.length === 0) {
        updatedList = [];
      }

      // updatedList = updatedList.filter((item) =>
      //   return item.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      // });

      // Trigger render with updated values
      setFilteredAreas(updatedList);
    }, 300),
    []
  );

  // const handleMomentumScrollEnd = () => {
  //     if (!isFullyOpen) {
  //         setIsFullyOpen(true);
  //     }
  // };

  // const handleDateTimeSelect = (dateTime, dateStr, time) => {
  //   const { partner, changeBookingTime } = props;

  //   // Pass through callback to parent
  //   props.onDateTimeSelect && props.onDateTimeSelect(dateTime, time);
  // };

  // const handleCtaClick = useCallback((e) => {

  //   if (props.activeState === 'dayTime') {
  //     // props.onSubmit && props.onSubmit();
  //     close();
  //   }

  //   props.onNextClick && props.onNextClick();

  // }, [props.activeState, props.onNextClick]);

  // const handleBackButtonClick = useCallback((e) => {
  //   if (props.activeState === 'sessionType') {
  //     props.changeDrawerState('goals');
  //   } else {
  //     props.changeDrawerState('sessionType');
  //   }

  // }, [props.activeState, props.changeDrawerState]);

  // const handleDateSelect = (date, dateStr, time) => {
  //   // const { partner, changeBookingTime } = props;

  //   // Pass through callback to parent
  //   props.onDateSelect && props.onDateSelect(date, time);
  // };

  // const { bottomBarHeight, refCallback, targetRef } = useBodyScrollLock(isOpen);
  useBodyScrollLock(isOpen);

  // const trainerPictureUrl = props.partner && getPartnerPictureUrl(props.partner);

  // const canBook = true;

  // const title = props.activeState === 'goals'
  //   ? 'Your goal'
  //   : props.activeState === 'dayTime'
  //     ? 'Day & Time'
  //     : 'Session type';

  // const subtitle = props.activeState === 'goals'
  //   ? 'What\'s your primary goal in fitness'
  //   : props.activeState === 'dayTime'
  //     ? 'When is more comfortable for you?'
  //     : 'Online or In-Person Session?';

  return (
    <aside className={classes.drawer}>
      {/*isOpen && backdropShow && <View style={panelStyles.backdrop} />*/}
      <SlidingUpPanel
        // @ts-ignore
        ref={panelRef}
        animatedValue={panelPositionVal}
        //allowDragging={isDraggable}
        allowDragging={props.allowDragging}
        draggableRange={draggableRange}
        snappingPoints={snappingPoints}
        // draggableRange={{ top: height - 24, bottom: '0' }}
        // snappingPoints={[118, height - 100]}

        // onDragStart={ (position) => { this.setState({ isDragged: true }); } }
        // onDragEnd={ (position) => { this.setState({ isDragged: false }); } }

        // onMomentumDragEnd={onMomentumDragEnd}
        // onDragStart={onDragStart}
        onBottomReached={handleBottomReached}
        // onFullyOpen={ () => setIsFullyOpen(true) }
        //snappingPoints={[panelExpandedY]}

        backdropStyle={panelStyles.backdrop}
        containerStyle={panelStyles.container}
        backdropOpacity={atBottom ? 0 : 0.75}
        showBackdrop={true}
        // showBackdrop={false}

        height={deviceHeight - 24}
        friction={0.4}
        // @ts-ignore
        children={dragHandlers => {
          return (
            <View
              // ref={refCallback}
              style={styles.container}
              // style={styles.panelContent}
            >
              {isOpen && (
                <>
                  <View
                    style={styles.panelHeader}
                    // justifyContent="space-between"
                    {...dragHandlers}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        marginTop: '4px',
                      }}
                    >
                      <button className={classes.closeDrawer} onClick={props.onClose}>
                        <CloseIcon />
                      </button>
                    </div>
                    <Typography
                      variant="button"
                      color="primary"
                      className={''}
                      style={{
                        flexGrow: 1,
                        marginTop: '3px',
                        marginBottom: '3px',
                        height: '26px',
                      }}
                    >
                      {props.title}
                    </Typography>
                  </View>

                  <div className={classes.districtInputContainer}>
                    {/*<InputLabel shrink htmlFor="input-passcode">
                Search a district
              </InputLabel>*/}
                    <TextField
                      id="input-district"
                      inputRef={districtInputRef}
                      onChange={handleDisctrictInputChange}
                      type="text"
                      // variant="outlined"
                      variant="standard"
                      placeholder="Search a district"
                      // size="small"
                      style={{ flexGrow: 1 }}
                      InputProps={{
                        // startAdornment: <AccountCircle />, // <== adjusted this
                        disableUnderline: true, // <== added this
                      }}
                    />
                  </div>

                  <RoundedContainer
                    // attachRef={refCallback}

                    // style={props.containerStyle}
                    style={{
                      height: '100%',
                      // height: 'calc(100vh - 139px)',
                      // 'min-height': '-webkit-fill-available',
                      // 'margin-bottom': 'env(safe-area-inset-bottom)',
                    }}
                    contentStyle={{
                      overflow: 'hidden',
                    }}
                    // style={{ height: 'calc(100% - 146px)' }}
                    // style={{ height: '100%'/*'calc(100% - 126px)'*/ }}
                    // innerContainerStyle={{ 'min-height': '100%', 'padding-bottom': 16 }}
                  >
                    <AddArea
                      isFetching={props.isFetching}
                      isFullyOpen={isFullyOpen}
                      height={deviceHeight}
                      scrollEnabled={true}
                      filteredAreas={filteredAreas}
                      onClose={props.onClose}
                      // onScroll={onScroll}
                    />
                  </RoundedContainer>
                </>
              )}
            </View>
          );
        }}
      ></SlidingUpPanel>
    </aside>
  );
});

// const getAreasBasedOnRegion = (region: string) => {
//   const allAreas: Area[] = region === 'US' ? areas : areasUK.map(mapAreaUKtoArea);

//   return allAreas;
// };

function mapAreaUKtoArea(val: AreaUK): Area {
  return {
    zipCode: val.outward, // default or derive from AreaUK properties
    city: val.town, // assume town is equivalent to city
    county: val.county,
    neighbourhood: undefined, // not present in AreaUK
    region: undefined, // not present in AreaUK
    coordinates: val.coordinates,
  };
}

type Style = {
  // panel: ViewStyle;
  container: ViewStyle;
  panelHeader: ViewStyle;
  // title: TextStyle;
  // icon: ImageStyle;
};

// const styles = StyleSheet.create<Style>({
//   panel: {
//     borderBottomColor: '#cbcfd5',
//     borderBottomWidth: 1,
//     'padding-top': '1rem',
//     'padding-bottom': '1rem',
//     'padding-right': '.5rem',
//     'padding-left': '.5rem',
//     'margin-right': '1rem',
//     'margin-left': '1rem',
//     'flex-direction':  'row',
//   },
//   container: {
//     flex: 1,
//     'background-color': 'rgb(255, 255, 255)',
//     'align-items': 'center',
//     'justify-content': 'center',
//     'border-radius': '8px',
//     height: '100%',
//   },
// });

const styles = StyleSheet.create<Style>({
  // panel: {
  //   borderBottomColor: '#cbcfd5',
  //   borderBottomWidth: 1,
  //   'padding-top': '1rem',
  //   'padding-bottom': '1rem',
  //   'padding-right': '.5rem',
  //   'padding-left': '.5rem',
  //   'margin-right': '1rem',
  //   'margin-left': '1rem',
  //   'flex-direction':  'row',
  // },
  container: {
    flex: 1,
    backgroundColor: 'rgb(255, 255, 255)',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    height: '100%',
  },

  panelHeader: {
    marginBottom: '-8px',
    backgroundColor: 'rgb(248, 248, 248)', // #F8F8F8
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    width: '100%',

    // userSelect: 'none',

    paddingTop: '8px', //16,
    paddingBottom: '16px',
    paddingLeft: '16px',
    paddingRight: '16px',
    // padding: '8px 16px 16px',

    // display="flex"
    textAlign: 'center',
    // padding: '8px 16px',
  },
});

// const containerStyles: React.CSSProperties = {
//   // container: { /* panel-body */
//     flex: 1,
//     'background-color': 'rgb(255, 255, 255)',
//     'align-items': 'center',
//     'justify-content': 'center',
//     'border-radius': '8px',
//     height: '100%',
//   // },
//   // panelHeader: {
//   //   'margin-bottom': '-8px',
//   //   'background-color': theme.greyLight,
//   //   'border-top-left-radius': '8px',
//   //   'border-top-right-radius': '8px',
//   // }
// };

// const panelHeaderStyles: React.CSSProperties = {
//   'margin-bottom': '-8px',
//   'background-color': theme.greyLight,
//   'border-top-left-radius': '8px',
//   'border-top-right-radius': '8px',
//   width: '100%',
//   userSelect: 'none',
//   // 'padding-top': 8, //16,
//   // 'padding-bottom': 8,
//   // 'padding-left': 16,
//   // 'padding-right': 16
//   padding: '8px 16px 16px',
// };

type PanelStyle = {
  backdrop: ViewStyle;
  container: ViewStyle;
  // title: TextStyle;
  // icon: ImageStyle;
};

const panelStyles = StyleSheet.create<PanelStyle>({
  backdrop: {
    // @ts-ignore
    position: 'fixed',
    // opacity: 0,
    // position: 'absolute',
    // 'z-index': 1000,

    // // position: absolute;
    // top: 0,
    // left: '0',
    // right: '0',
    // bottom: '0',
    // 'background-color': 'rgb(0, 0, 0)',
    // // z-index: 1000;
    // opacity: 0.75,
    // // 'pointer-events': 'auto'
  },
  container: {
    // @ts-ignore
    position: 'fixed',
    // position: 'absolute',
    zIndex: 1004, // more than Bottom Navigation
  },
});

AddAreaPopup.displayName = 'AddAreaPopup';
// Drawer.propTypes = propTypes;
AddAreaPopup.defaultProps = defaultProps;

// const mapStateToProps = (state, ownProps) => ({});

// const dispatchProps = {
//   changeDrawerState,
//   // loadPartnerProfile,
// };

// export default connect(
//   mapStateToProps,
//   dispatchProps,
//   null,
//   { forwardRef: true }
// )(Drawer);
